/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Filter_Last_WeeksInputs */

const en_ui_filter_last_weeks = /** @type {(inputs: Ui_Filter_Last_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`last ${i?.count} weeks`)
};

const de_ui_filter_last_weeks = /** @type {(inputs: Ui_Filter_Last_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`letzte ${i?.count} Wochen`)
};

/**
* | output |
* | --- |
* | "last {count} weeks" |
*
* @param {Ui_Filter_Last_WeeksInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_last_weeks = /** @type {((inputs: Ui_Filter_Last_WeeksInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Last_WeeksInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_last_weeks(inputs)
	return de_ui_filter_last_weeks(inputs)
});